import { render, staticRenderFns } from "./corporate-list.vue?vue&type=template&id=bd86dd4a"
import script from "./corporate-list.vue?vue&type=script&lang=js"
export * from "./corporate-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports